export function ok(data) {
    return { success: true, data };
}
export function fail(error, errorType) {
    return { success: false, error, errorType };
}
export function isOk(result) {
    return result.success;
}
export function isFail(result) {
    return !result.success;
}
